import { defineModule } from "../define.ts";

/**
 * Lost and found (PMU-236): things children leave at school or on the bus. Staff log an item with a
 * photo; the parents who could own it see it; staff name the owner or a parent claims it; the
 * handover is recorded and the parents told. On for every organisation (a school or a bus company).
 */
export const lostfound = defineModule({
  id: "lostfound",
  name: "Lost and found",
  version: "0.1.0",
  description: "Things left at school or on the bus: logged with a photo, claimed, handed back.",
  core: true,
  // Every member of staff logs and hands over; bus crews and dispatchers get it with their roles (transport manifest).
  grants: { "lostfound:use": ["org_admin", "site_admin", "door_staff", "teacher"] },
});
